import { render, staticRenderFns } from "./plan-management.vue?vue&type=template&id=b898c5c0&scoped=true"
import script from "./plan-management.vue?vue&type=script&lang=js"
export * from "./plan-management.vue?vue&type=script&lang=js"
import style0 from "./plan-management.vue?vue&type=style&index=0&id=b898c5c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b898c5c0",
  null
  
)

export default component.exports